import { useMemo } from "react";
import { ProductionTask_Input } from "@/api/models/ProductionTask_Input";
import SummaryCard from "@/components/SummaryCard";

interface ProductionTaskSummaryProps {
  tasks: Array<ProductionTask_Input>;
}

const ProductionTaskSummary = ({ tasks }: ProductionTaskSummaryProps) => {
  const taskCount = tasks.length;
  const totalQuantity = useMemo(() => tasks.reduce((sum, task) => sum + (task.quantity || 0), 0), [tasks]);
  const uniqueSkus = useMemo(() => new Set(tasks.map(task => task.sku_id)).size, [tasks]);
  const uniqueMachines = useMemo(() => new Set(tasks.map(task => task.machine_id)).size, [tasks]);
  const fixedTaskCount = useMemo(() => tasks.filter(task => task.is_fixed).length, [tasks]);

  return (
    <div className="tw-grid tw-grid-cols-5 tw-gap-4 py-4">
      <SummaryCard title="成形回数" target={taskCount} className="flex-1/5" />
      <SummaryCard title="生産数量合計" target={totalQuantity} className="flex-1/5" />
      <SummaryCard title="SKU数" target={uniqueSkus} className="flex-1/5" />
      <SummaryCard title="設備数" target={uniqueMachines} className="flex-1/5" />
      <SummaryCard title="固定タスク" target={fixedTaskCount} className="flex-1/5" />
    </div>
  );
};

export default ProductionTaskSummary;
